// Color names choosen by http://chir.ag/projects/name-that-color

export const colors = {
  botticelli: 'botticelli',
  chambray: 'chambray',
  chambrayLight: 'chambrayLight',
  catskillWhite: 'catskillWhite',
  catskillGray: 'catskillGray',
  torchRed: 'torchRed',
  lavenderBlush: 'lavenderBlush',
  pastelPink: 'pastelPink',
  chablis: 'chablis',
  white: 'white',
  black: 'black',
  fog: 'fog',
  silver: 'silver',
  gray: 'gray',
  darkGray: 'darkGray',
  shuttleGray: 'shuttleGray',
  alto: 'alto',
  abbey: 'abbey',
  titanWhite: 'titanWhite',
  funGreen: 'funGreen',
  pastelGreen: 'pastelGreen',
  madang: 'madang',
  indigo: 'indigo',
  melrose: 'melrose',
  lightMelrose: 'lightMelrose',
  whisper: 'whisper',
  shark: 'shark',
  pigeonPost: 'pigeonPost',
  darkBlue: 'darkBlue',
  nepal: 'nepal',
  transparent: 'transparent',
  dodgerBlue: 'dodgerBlue',
  silverSand: 'silverSand',
  osloGray: 'osloGray',
  waikawaGray: 'waikawaGray',
  feta: 'feta',
  fetaLight: 'fetaLight',
  zircon: 'zircon',
  frenchGray: 'frenchGray',
  astronaut: 'astronaut',
  serenade: 'serenade',
  malachite: 'malachite',
  unset: 'unset',
  orangePeel: 'orangePeel',
  chenin: 'chenin',
  anakiwa: 'anakiwa',
  pictonBlue: 'pictonBlue',
  cerulean: 'cerulean',
  blueStone: 'blueStone',
  seaNymph: 'seaNymph',
  riptide: 'riptide',
  bridalHeath: 'bridalHeath',
  deluge: 'deluge',
  mossGreen: 'mossGreen',
  cottonCandy: 'cottonCandy',
  persianPink: 'persianPink',
  amaranth: 'amaranth',
  gallery: 'gallery',
  portage: 'portage',
  peachOrange: 'peachOrange',
  malachiteB: 'malachiteB',
  neonCarrot: 'neonCarrot',
  radicalRed: 'radicalRed',
  terracotta: 'terracotta',
  athensGray: 'athensGray',
  havelockBlue: 'havelockBlue',
  frenchGrey: 'frenchGrey',
};

export const __colors = {
  [colors.unset]: 'unset',
  [colors.transparent]: '#00000000',
  [colors.botticelli]: '#D8DEEA',
  [colors.white]: '#FFFFFF',
  [colors.serenade]: '#FFF5E5',
  [colors.chablis]: '#FFF4F4',
  [colors.catskillGray]: '#F5F7FA',
  [colors.whisper]: '#F5F6FA',
  [colors.fetaLight]: '#EFFDF1',
  [colors.titanWhite]: '#EEF0FF',
  [colors.catskillWhite]: '#EBEEF5',
  [colors.alto]: '#E0E0E0',
  [colors.lightMelrose]: '#BBC2FF',
  [colors.feta]: '#DEFBE3',
  [colors.pigeonPost]: '#B1BDD6',
  [colors.frenchGray]: '#BFC0C4',
  [colors.silver]: '#BDBDBD',
  [colors.silverSand]: '#BDC1C6',
  [colors.osloGray]: '#909192',
  [colors.gray]: '#828282',
  [colors.darkGray]: '#636262',
  [colors.shuttleGray]: '#61656C',
  [colors.abbey]: '#46484D',
  [colors.shark]: '#222326',
  [colors.black]: '#000000',
  [colors.orangePeel]: '#FF9800',
  [colors.torchRed]: '#FF143C',
  [colors.lavenderBlush]: '#FFF3F5',
  [colors.pastelPink]: '#FFD0D8',
  [colors.madang]: '#BEF7C7',
  [colors.pastelGreen]: '#5CEB73',
  [colors.funGreen]: '#009317',
  [colors.malachite]: '#00B81D',
  [colors.melrose]: '#AC98FF',
  [colors.nepal]: '#899BC1',
  [colors.chambrayLight]: '#4da9f4',
  [colors.dodgerBlue]: '#5467FF',
  [colors.indigo]: '#4451BF',
  [colors.waikawaGray]: '#627AAD',
  [colors.chambray]: '#3B5998',
  [colors.astronaut]: '#2C4373',
  [colors.darkBlue]: '#1A2E58',
  [colors.chenin]: '#E5DA71',
  [colors.anakiwa]: '#98DAFF',
  [colors.pictonBlue]: '#40B2F2',
  [colors.blueStone]: '#005F54',
  [colors.seaNymph]: '#7DA6A1',
  [colors.riptide]: '#96ECE2',
  [colors.bridalHeath]: '#FFFAF2',
  [colors.deluge]: '#8367AF',
  [colors.mossGreen]: '#9ED99B',
  [colors.cottonCandy]: '#FFAFE9',
  [colors.persianPink]: '#F97DC7',
  [colors.amaranth]: '#EA3856',
  [colors.alto]: '#D3D3D3',
  [colors.gallery]: '#EDEDED',
  [colors.portage]: '#9077F6',
  [colors.peachOrange]: '#FFD699',
  [colors.malachiteB]: '#0AD570',
  [colors.cerulean]: '#10B9D0',
  [colors.neonCarrot]: '#FF993B',
  [colors.radicalRed]: '#FF1C52',
  [colors.terracotta]: '#E86C60',
  [colors.athensGray]: '#F8F8F9',
  [colors.havelockBlue]: '#7288E2',
  [colors.fog]: '#D9DCFE',
  [colors.zircon]: '#F5F6FF',
};

/**
 * @deprecated
 */
export const hexToRGB = hex =>
  hex
    .substr(1)
    .match(/.{1,2}/g)
    .map(c => parseInt(c, 16));

/**
 * @deprecated
 * use `alpha` helper from `@mui/material`
 */
export const hexToRGBA = (hex, alpha) => `rgba(${hexToRGB(hex)}, ${alpha})`;

/**
 * @deprecated
 */
export const getColor = (_color = 'shark', alpha) => {
  const color = __colors[_color];
  if (!color) {
    throw new Error(`color ${_color} does not match`);
  }
  return alpha ? hexToRGBA(color, alpha) : color;
};
